import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Form, Button } from "react-bulma-components";
import { connect } from "react-redux";
import styles from "./StarshopPurchaseModal.module.sass";

const StarshopPurchaseModal = ({ onClose, onConfirm }) => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const validateMessage = (input) => {
    const tagRegex = /<\/?[^>]+(>|$)/g;

    if (tagRegex.test(input)) {
      return "HTML tags are not allowed.";
    }

    return "";
  };

  const handleConfirm = () => {
    const errorMessage = validateMessage(message);

    if (errorMessage) {
      setError(errorMessage);
      return;
    }

    setError(""); 
    onConfirm(message.trim());
  };

  return (
    <Modal.Card>
      <Modal.Card.Head showClose={false}>
        <Modal.Card.Title>Confirm Purchase</Modal.Card.Title>
      </Modal.Card.Head>
      <Modal.Card.Body>
        <Form.Field>
          <Form.Label>Comment (Shirt size, etc.)</Form.Label>
          <Form.Textarea
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setError(validateMessage(e.target.value)); // Live validation
            }}
            className={error ? "is-danger" : ""}
            placeholder="Specify details like size, color, etc."
          />
          {error && <p className="error-text">{error}</p>}
        </Form.Field>

        <p className={`${styles.confirmText}`}>Are you sure?</p>

        <Form.Field kind="group">
          <Form.Control>
            <Button color="success" onClick={handleConfirm} disabled={!!error}>
              Confirm
            </Button>
          </Form.Control>
          <Form.Control>
            <Button color="" colorVariant="light" onClick={onClose}>
              Cancel
            </Button>
          </Form.Control>
        </Form.Field>
      </Modal.Card.Body>
    </Modal.Card>
  );
};

StarshopPurchaseModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(StarshopPurchaseModal);
